import { default as MovieCard, MovieCardProps } from '@/components/shared/movie-card';

import { FC } from 'react';
import { useTheme } from '@mui/material';

export interface FinderMovieCardProps extends MovieCardProps {
  isSelected: boolean;
  isDisabled: boolean;
  onClick: () => void;
}

export const FinderMovieCard: FC<FinderMovieCardProps> = ({
  isSelected,
  isDisabled,
  onClick,
  ...props
}) => {
  const theme = useTheme();

  return (
    <MovieCard
      {...props}
      component={'button'}
      componentProps={{ onClick }}
      sx={{
        cursor: 'pointer',
        border: 'none',
        outline:
          isSelected && !isDisabled
            ? `solid 2px ${theme.palette.primary.main}`
            : 'solid 0px transparent',

        ...(isDisabled && {
          opacity: 0.5,
          cursor: 'not-allowed',
        }),
      }}
    />
  );
};
